import {
    HorizAlignment,
    ISearch, ISearchProfile, ISearchProvider, ISearchRequestSubset,
    SearchProviderFieldType, ISearchProviderField
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";


const vUI_Application_Search_Fields: {[id:string]: ISearchProviderField } = {
    WB_UI_APP_ID: {type: SearchProviderFieldType.number, renderOptions: { columnName: 'WBId',       columnResourceName: 'colWBId',     alignment: HorizAlignment.Right}, domainOptions: { maxLength: 50}},
    APP_ID:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'App Id',     columnResourceName: 'colId',       alignment: HorizAlignment.Left}, domainOptions: {}},
    APP_NAME:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'App Name',   columnResourceName: 'colName',     alignment: HorizAlignment.Left}, domainOptions: {}},
    GROUP_NAME:   {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Group Name', columnResourceName: 'colGroup',    alignment: HorizAlignment.Left}, domainOptions: {}},
    KEYWORDS:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Keywords',   columnResourceName: 'colKeywords', alignment: HorizAlignment.Left}, domainOptions: {}},
    SORT_ORDER:   {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Sort',       columnResourceName: 'colSort',     alignment: HorizAlignment.Right, numberFormat: "#,##0", columnWidthCharacters: 10}, domainOptions: { maxLength: 50}},
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
}

const UIApplicationSearchProviderBasic: ISearchProvider = {

    keyFields: {id:    'WB_UI_APP_ID',
        id_ui: 'APP_ID',
        name:  'APP_NAME'},

    searchProviderFields: vUI_Application_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_Application_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }

}

const UIApplicationSearchApplicationByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "UIApplicationSearchApplicationByName" },

    profileFilter: [
        {profileFilterName: 'Id',     searchProviderFieldId: 'APP_ID', renderOptions: { }},
        {profileFilterName: 'Name',   searchProviderFieldId: 'APP_NAME', renderOptions: { }}
    ],  // ISearchFields
    profileDisplayFields: [
        'APP_ID','APP_NAME','GROUP_NAME','KEYWORDS','SORT_ORDER',
        'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: UIApplicationSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}


const UIApplicationSearch: ISearch = {
    searchName: "Find Application",
    renderOptions: { ui5ResourceId: "UIApplicationSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [UIApplicationSearchApplicationByName]
}

PAEnvironment.registerBusinessObjectSearch("UIApplicationBO", "Application", UIApplicationSearch, "Application Search")

export {UIApplicationSearch}